import { UserService } from './UserService';

class LocalStorageService {
  storage: any;

  constructor() {
    this.storage = localStorage;
  }

  public static Get = (name: string): any => {
    const optionname = this.OptionName(name);
    if (optionname === null || localStorage[optionname] == null) {
      return null;
    }
    const options = JSON.parse(localStorage[optionname]);
    return options;
  };

  public static GetExact = (name: string): any => {
    if (localStorage[name] == null) {
      return null;
    }
    const options = JSON.parse(localStorage[name]);
    return options;
  };

  public static Set = (name: string, options: any) => {
    const optionname = this.OptionName(name);
    if (optionname !== null) {
      localStorage[optionname] = JSON.stringify(options);
    }
  };

  public static Remove = (name: string, isExact: boolean = false) => {
    const optionname = !isExact ? this.OptionName(name) : name;
    if (optionname !== null) {
      localStorage.removeItem(optionname);
    }
  };

  private static OptionName = (name: string): string | null => {
    const user = UserService.GetUser();
    if (user !== null) {
      const optionname = name;
      return optionname;
    } else {
      return name + '1'; //TODO: this need to change after auth is implemented
    }
    // return null;
  };
}

export { LocalStorageService };
